import(/* webpackMode: "eager" */ "/codebuild/output/src739519374/src/new-celestial-2025/src/app/[locale]/blog/[id]/loading.js");
